// extracted by mini-css-extract-plugin
export default {"root":"PlasmicInvoicebutton_root__moQ-0","text":"PlasmicInvoicebutton_text__8LP66"};